import React, { useState, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './CollapseCard.module.scss';
import Text from 'common/components/Text/Text';
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';

interface CardProps {
  name: string;
  status: string;
  text?: string;
  button?: string;
  link?: string;
  handleFile?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  buttonValue?: string;
  handleFormik?: (field: string, value: boolean) => void;
}

interface ButtonProps {
  button: string;
  link?: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  status: boolean;
  showOpenFileDialog: () => void;
  value?: string;
}

const handleText = (button: string, status: boolean) => {
  if (button === 'check') {
    return status ? 'Checked' : 'Check';
  } else if (button === 'download') {
    return 'Download';
  } else if (button === 'upload') {
    return status ? 'Uploaded' : 'Upload';
  }
};

const buttonType = ({
  button,
  link,
  handleClick,
  status,
  showOpenFileDialog,
  value,
}: ButtonProps) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  if (button === 'check') {
    return (
      <button
        className={`${styles.button} btn ${status ? styles.active : ''}`}
        type="button"
        onClick={handleClick}
        value={value}
      >
        <Text size={isMobile ? 12 : 16} weight={600}>
          {handleText(button, status)}
        </Text>
      </button>
    );
  } else if (button === 'download' && link) {
    return (
      <a className={`${styles.button} btn`} type="button" href={link}>
        <Text size={isMobile ? 12 : 16} weight={600}>
          {handleText(button, status)}
        </Text>
      </a>
    );
  } else if (button === 'upload') {
    return (
      <button
        className={`${styles.button} btn ${status ? styles.active : ''}`}
        onClick={showOpenFileDialog}
        type="button"
      >
        <Text size={isMobile ? 12 : 16} weight={600}>
          {handleText(button, status)}
        </Text>
      </button>
    );
  }
};
const CollapseCard = ({
  name,
  status,
  text,
  button,
  link,
  handleFile,
  handleFormik,
  buttonValue,
}: CardProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [open, setOpen] = useState(false);
  const [check, setCheck] = useState(
    status === 'active' || status === 'uploaded' || status === 'approved'
  );
  const fileRef = useRef<HTMLInputElement>(null);
  const showOpenFileDialog = () => {
    fileRef?.current?.click();
  };

  const handleClick = async () => {
    setCheck(!check);
    if (buttonValue && buttonValue !== 'none' && handleFormik) {
      handleFormik(buttonValue, !check);
    }
  };
  return (
    <div>
      {isMobile ? (
        <div className={styles.collapseCard}>
          <Button
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            className={styles.collapseButton}
            aria-controls={name}
          >
            <div className={styles.wrap}>
              <i className={`bi bi-check-circle ${check ? styles.active : ''}`}></i>
              <Text size={14} weight={500} color="primary">
                {name}
              </Text>
              {button === 'upload' && (
                <input
                  type="file"
                  style={{ display: 'none' }}
                  accept=".pdf, .jpg, .png"
                  name="fee"
                  onChange={handleFile}
                  ref={fileRef}
                />
              )}
            </div>
          </Button>
          {button &&
            buttonType({
              button,
              link,
              handleClick,
              status: check,
              showOpenFileDialog,
              value: buttonValue,
            })}
          <Collapse in={open}>
            <div id={name} className={styles.collapseBody}>
              <Text size={14}>{text}</Text>
            </div>
          </Collapse>
        </div>
      ) : (
        <div className={styles.collapseCard}>
          <div className={styles.header}>
            <div className={styles.wrapper}>
              <i className={`bi bi-check-circle ${check ? styles.active : ''}`}></i>
              <Text
                size={16}
                weight={500}
                color="primary"
                inlineStyle={{ width: '255px', display: 'flex', gap: '5px', alignItems: 'center' }}
              >
                {name}
              </Text>
              {button === 'upload' && (
                <div className={`${styles.status} ${styles[status]}`}>{status}</div>
              )}
              {button === 'upload' && (
                <input
                  type="file"
                  style={{ display: 'none' }}
                  accept=".pdf, .jpg, .png"
                  name="universityFee"
                  onChange={handleFile}
                  ref={fileRef}
                />
              )}
            </div>
            <div className={styles.secondWrap}>
              {button &&
                buttonType({
                  button,
                  link,
                  handleClick,
                  status: check,
                  showOpenFileDialog,
                  value: buttonValue,
                })}
              <Button
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                className={styles.collapseButton}
                aria-controls={name}
                type="button"
              >
                <div>
                  <i className={open ? 'bi bi-chevron-up' : 'bi bi-chevron-down'}></i>
                </div>
              </Button>
            </div>
          </div>
          <div>
            <Collapse in={open}>
              <div id={name} className={styles.collapseBody}>
                <Text>{text}</Text>
              </div>
            </Collapse>
          </div>
        </div>
      )}
    </div>
  );
};

export default CollapseCard;
